export { AdminConnection } from '@iobroker/socket-client';
